import { render, staticRenderFns } from "./MdmVideoSrcset.vue?vue&type=template&id=9b517640&"
import script from "./MdmVideoSrcset.vue?vue&type=script&lang=js&"
export * from "./MdmVideoSrcset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports